import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './translations/en/translation.json';
import fr from './translations/fr/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    lng: navigator.language.split('-')[0] , // Détecte la langue du navigateur
    fallbackLng: 'en', // Langue par défaut
    interpolation: {
      escapeValue: false, // React gère la protection XSS
    },
  });

export default i18n;
